export default {
  state: {
    mainIcon: {
      background: '#ff2f00',
      icon: 'https://static.dnipro-m.ua/origin/chat/messenger-1.svg',
      closeIcon: 'https://static.dnipro-m.ua/origin/chat/interface-1.svg',
      closeBackground: '#fff'
    },
    chats: [
      {
        id: 1,
        name: 'chat',
        label: 'Чат',
        background: '#ff2f00',
        icon: 'https://static.dnipro-m.ua/origin/chat/communications-2.svg',
        link: '#'
      },
      {
        id: 2,
        name: 'phone',
        label: 'Телефон',
        background: '#ff2f00',
        icon: 'https://static.dnipro-m.ua/origin/chat/phoneicon-1.svg',
        link: 'tel:0800200500'
      },
      {
        id: 3,
        name: 'viber',
        label: 'Viber',
        background: '#665cac',
        icon: 'https://static.dnipro-m.ua/origin/chat/vb.svg',
        link: 'viber://pa?chatURI=dnipro_m_bot'
      },
      {
        id: 4,
        name: 'messenger',
        label: 'Messenger',
        background: '#4267b2',
        icon: 'https://static.dnipro-m.ua/origin/chat/fb.svg',
        link: 'https://m.me/795514890478433'
      },
      {
        id: 5,
        name: 'telegram',
        label: 'Telegram',
        background: '#0088cc',
        icon: 'https://static.dnipro-m.ua/origin/chat/tg.svg',
        link: 'https://telegram.me/dnipro_m_bot'
      }
    ],
    isOpen: false
  },
  mutations: {
    OPEN_CHATS_LIST (state, bool) {
      state.isOpen = bool
    }
  },
  actions: {
    SET_CHATS_LIST_STATUS: (ctx, bool) => {
      ctx.commit('OPEN_CHATS_LIST', bool)
    }
  }
}
